import { render } from "./TotalClaim.vue?vue&type=template&id=7ea57bd8"
import script from "./TotalClaim.vue?vue&type=script&lang=js"
export * from "./TotalClaim.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__